'use client';
import { createContext } from '@chakra-ui/utils/context';

const [DrawerContextProvider, useDrawerContext] = createContext();

export { DrawerContextProvider, useDrawerContext };
